<template>
  <article id="single-page" class="container" v-if="loaded">
    <h1>{{page.title.rendered}}</h1>
    <div v-html="page.excerpt.rendered"></div>
    <!-- <lottie :options="defaultOptions" :height="720" :width="1024" v-on:animCreated="handleAnimation" /> -->
  </article>
</template>

<script>
import { settings } from '../variables.js'
// import Lottie from 'vue-lottie'
// import * as animationCreatie from '../assets/animations/creatie.json'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

export default {
  name: 'page',
  components: {
    // 'lottie': Lottie
  },
  data () {
    return {
      page: {},
      // defaultOptions: { animationData: animationCreatie.default, loop: false, autoPlay: true },
      animationText: 'This is my text'
    }
  },
  created: function () {
    this.getData(this.$route.params.pageSlug)
  },
  watch: {
    '$route.params.pageSlug': function (pageSlug) {
      this.getData(pageSlug)
    }
  },
  methods: {
    getData: function (pageSlug) {
      this.axios
        .get(settings.jsonUrl + 'wp/v2/pages?slug=' + pageSlug)
        .then(response => (this.page = response.data[0]))
        .then(function (result) {
          NProgress.done()
        })
        .catch(error => console.log(error))
    },
    handleAnimation: function (anim) {
      this.anim = anim
      // let c = document.getElementById('changetext')
      // let t = c.querySelector('tspan')
      // let t = c.querySelectorAll('text')[0]
      // t.textContent = this.animationText
    }
  },
  computed: {
    loaded () {
      return !(Object.entries(this.page).length === 0 && this.page.constructor === Object)
    },
    members () {
      return this.$store.state.teamModule.members
    }
  }
}
</script>
